import React from 'react';

export default function Picker({options, value, onChange, name}) {
	return (
		<>
			{options.map(i => (
				<label className="option flex" key={i.value}>
					<input type="radio" value={i.value} name={name} disabled={i.disabled} checked={value===i.value} onChange={onChange} />
					<div className="">{i.label}</div>
				</label>
			))}
		</>
	)
}
